import { aiAgentsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_AGENTS_ACTION_TYPE = createNamedActions('aiAgents', {
  GET_AI_AGENTS: 'GET_AI_AGENTS',
  GET_AI_AGENT_TEMPLATES: 'GET_AI_AGENT_TEMPLATES',
  CREATE_AI_AGENT: 'CREATE_AI_AGENT',
  UPDATE_AI_AGENT: 'UPDATE_AI_AGENT',
  DELETE_AI_AGENT: 'DELETE_AI_AGENT',
  CLONE_AI_AGENT: 'CLONE_AI_AGENT',
  ENABLE_AI_AGENT: 'ENABLE_AI_AGENT',
  DISABLE_AI_AGENT: 'DISABLE_AI_AGENT',
  RESET_AI_AGENTS_STATE: 'RESET_AI_AGENTS_STATE',
});

export const getAiAgentsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await aiAgentsApi.getAiAgents();

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.GET_AI_AGENTS,
    payload: data,
  });
});

export const getAiAgentTemplatesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await aiAgentsApi.getAiAgentTemplates();

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.GET_AI_AGENT_TEMPLATES,
    payload: data,
  });
});

export const createAiAgentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiAgentsApi.createAiAgent(params);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.CREATE_AI_AGENT,
    payload: data,
  });
});

export const updateAiAgentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiAgentsApi.updateAiAgent(params);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.UPDATE_AI_AGENT,
    payload: data,
  });
});

export const deleteAiAgentAction = catchAsyncActionError(id => async dispatch => {
  await aiAgentsApi.deleteAiAgent(id);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.DELETE_AI_AGENT,
    payload: id,
  });
});

export const cloneAiAgentAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiAgentsApi.cloneAiAgent(id);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.CLONE_AI_AGENT,
    payload: data,
  });
});

export const enableAiAgentAction = catchAsyncActionError(id => async dispatch => {
  await aiAgentsApi.enableAiAgent(id);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.ENABLE_AI_AGENT,
    payload: id,
  });
});

export const disableAiAgentAction = catchAsyncActionError(id => async dispatch => {
  await aiAgentsApi.disableAiAgent(id);

  return dispatch({
    type: AI_AGENTS_ACTION_TYPE.DISABLE_AI_AGENT,
    payload: id,
  });
});

export const resetAiAgentsStateAction = () => ({
  type: AI_AGENTS_ACTION_TYPE.RESET_AI_AGENTS_STATE,
});
